
	import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";

	import VuePerfectScrollbar from "vue-perfect-scrollbar";

	@Component({
		components: {
			VuePerfectScrollbar: VuePerfectScrollbar
		}
	})
	export default class OverflowSelect extends Vue {
		$refs!: {
			optionsScrollBar: any;
			toggleBox: HTMLDivElement;
		};

		@Prop()
		public value: any;

		@Prop({ type: Array, default: [] })
		public options: any[];

		@Prop({ type: Boolean, default: false })
		public disabled: boolean;

		@Prop({ type: Boolean, default: false })
		public multiple: boolean;

		@Prop({ type: String, default: "" })
		public placeholder: string;

		@Prop({ type: String, default: "" })
		public label: string;

		@Prop({ type: Function, default: option => option })
		public reduce: (option: any) => any;

		public searchQuery: string = "";

		private get selectedValue () {
			let value = this.value;
			if (value) {
				return [].concat(value);
			}
			return [];
		}

		public get selectedOptions () {
			const selectedValues = new Set(this.selectedValue);
			return this.options.filter(option => selectedValues.has(this.reduce(option)) );
		}

		@Watch("value")
		private onValueChanged (newValue) {
			if (newValue) {
				// Do nothing
			}
		}

		private menuStyle: any = {
			top: "0px",
			left: "0px",
			width: "auto"
		}

		private filterFocus: boolean = false;

		private onSearchFocus(): void {
			const left = (this.$refs.toggleBox.offsetParent as HTMLElement).offsetLeft +
				this.$refs.toggleBox.offsetLeft;

			const top = this.$refs.toggleBox.getBoundingClientRect().top;
			this.menuStyle.top = top + "px";
			this.menuStyle.left = left + "px";
			this.menuStyle.width = (this.$refs.toggleBox.offsetWidth + 2) + "px";

			const maxHeight = document.documentElement.clientHeight - top - 40;
			this.menuStyle.maxHeight = Math.min(250, maxHeight) + "px";

			this.filterFocus = true;
		}

		/**
		 * When filter is blurred, close dropdown
		 */
		private onSearchBlur (): void {
			setTimeout(() => this.loseFocus(), 500);
		}

		private loseFocus() {
			this.searchQuery = "";
			this.filterFocus = false
		}

		private getOptionLabel (option): string {
			if (this.label && option.hasOwnProperty(this.label)) {
				return option[this.label];
			}
			return option || "";
		}

		private getOptionKey (option): string {
			return JSON.stringify(this.reduce(option));
		}

		private get filteredOptions () {
			const searchQuery = this.searchQuery.toLocaleLowerCase();
			let options = this.searchQuery.length
				? this.options.filter(option => this.getOptionLabel(option).toLowerCase().indexOf(searchQuery) > -1)
				: this.options;
			return options;
		}

		private isOptionSelected (option): boolean {
			return false;
		}

		private selectable (option): boolean {
			return true;
		}

		public selectOption (option) {
			if (this.isOptionSelected(option)) {
				return;
			}

			if (this.multiple) {
            	option = this.selectedValue.concat(option)
			}

			this.updateValue(option);
		}

		private updateValue (selectedValue): void {
			const newValue = Array.isArray(selectedValue)
				? selectedValue.map(val => this.reduce(val))
				: this.reduce(selectedValue);

			this.$emit("input", newValue);
			this.loseFocus();
			this.$emit("change", newValue);
		}

		private normalizeOptionForSlot (option) {
			return (typeof option === "object") ? option : { [this.label]: option };
		}

		private deselect (option) {
			// Do nothing
		}
	}
